export const GET_ASSET_MANAGER_CATEGORIES_START = 'GET_ASSET_MANAGER_CATEGORIES_START';
export const GET_ASSET_MANAGER_CATEGORIES_SUCCESS = 'GET_ASSET_MANAGER_CATEGORIES_SUCCESS';
export const GET_ASSET_MANAGER_CATEGORIES_FAILED = 'GET_ASSET_MANAGER_CATEGORIES_FAILED';

export const GET_ASSET_MANAGER_CATEGORY_TAGS_START = 'GET_ASSET_MANAGER_CATEGORY_TAGS_START';
export const GET_ASSET_MANAGER_CATEGORY_TAGS_SUCCESS = 'GET_ASSET_MANAGER_CATEGORY_TAGS_SUCCESS';
export const GET_ASSET_MANAGER_CATEGORY_TAGS_FAILED = 'GET_ASSET_MANAGER_CATEGORY_TAGS_FAILED';

export const GET_ASSET_MANAGER_TAG_BY_CODE_START  = 'GET_ASSET_MANAGER_TAG_BY_CODE_START';
export const GET_ASSET_MANAGER_TAG_BY_CODE_SUCCESS = 'GET_ASSET_MANAGER_TAG_BY_CODE_SUCCESS';
export const GET_ASSET_MANAGER_TAG_BY_CODE_FAILED  = 'GET_ASSET_MANAGER_TAG_BY_CODE_FAILED';

export const GET_ASSET_MANAGER_IMAGES_START = 'GET_ASSET_MANAGER_IMAGES_START';
export const GET_ASSET_MANAGER_IMAGES_SUCCESS = 'GET_ASSET_MANAGER_IMAGES_SUCCESS';
export const GET_ASSET_MANAGER_IMAGES_FAILED = 'GET_ASSET_MANAGER_IMAGES_FAILED';

export const UPLOAD_PROVIDER_IMAGE_START = 'UPLOAD_PROVIDER_IMAGE_START';
export const UPLOAD_PROVIDER_IMAGE_SUCCESS = 'UPLOAD_PROVIDER_IMAGE_SUCCESS';
export const UPLOAD_PROVIDER_IMAGE_FAILED = 'UPLOAD_PROVIDER_IMAGE_FAILED';

export const UPLOAD_PRIVATE_IMAGE_START = 'UPLOAD_PRIVATE_IMAGE_START';
export const UPLOAD_PRIVATE_IMAGE_SUCCESS = 'UPLOAD_PRIVATE_IMAGE_SUCCESS';
export const UPLOAD_PRIVATE_IMAGE_FAILED = 'UPLOAD_PRIVATE_IMAGE_FAILED';


export const getAssetManagerCategoriesStart = () => ({
  type: GET_ASSET_MANAGER_CATEGORIES_START
});

export const getAssetManagerCategoriesSuccess = (data) => ({
  type: GET_ASSET_MANAGER_CATEGORIES_SUCCESS,
  data
});

export const getAssetManagerCategoriesFailed = (error) => ({
  type: GET_ASSET_MANAGER_CATEGORIES_FAILED,
  error
});

export const getAssetManagerCategoryTagsStart = () => ({
  type: GET_ASSET_MANAGER_CATEGORY_TAGS_START
});

export const getAssetManagerCategoryTagsSuccess = (data, currentCategoryData) => ({
  type: GET_ASSET_MANAGER_CATEGORY_TAGS_SUCCESS,
  data,
  currentCategoryData
});

export const getAssetManagerCategoryTagsFailed = (error) => ({
  type: GET_ASSET_MANAGER_CATEGORY_TAGS_FAILED,
  error
});

export const getAssetManagerTagByCodeStart   = () => ({
  type: GET_ASSET_MANAGER_TAG_BY_CODE_START
});

export const getAssetManagerTagByCodeSuccess = (data) => ({
  type: GET_ASSET_MANAGER_TAG_BY_CODE_SUCCESS,
  data
});

export const getAssetManagerTagByCodeFailed  = (error) => ({
  type: GET_ASSET_MANAGER_TAG_BY_CODE_FAILED,
  error
});

export const getAssetManagerImagesStart = () => ({
  type: GET_ASSET_MANAGER_IMAGES_START
});

export const getAssetManagerImagesSuccess = (data, tagId, isPrivate) => ({
  type: GET_ASSET_MANAGER_IMAGES_SUCCESS,
  data,
  tagId,
  isPrivate
});

export const getAssetManagerImagesFailed = (error) => ({
  type: GET_ASSET_MANAGER_IMAGES_FAILED,
  error
});

export const uploadProviderImageStart = () => ({
  type: UPLOAD_PROVIDER_IMAGE_START
});

export const uploadProviderImageSuccess = (data) => ({
  type: UPLOAD_PROVIDER_IMAGE_SUCCESS,
  data
});

export const uploadProviderImageFailed = (error) => ({
  type: UPLOAD_PROVIDER_IMAGE_FAILED,
  error
});

export const uploadPrivateImageStart = () => ({
  type: UPLOAD_PRIVATE_IMAGE_START
});

export const uploadPrivateImageSuccess = (data) => ({
  type: UPLOAD_PRIVATE_IMAGE_SUCCESS,
  data
});

export const uploadPrivateImageFailed = (error) => ({
  type: UPLOAD_PRIVATE_IMAGE_FAILED,
  error
});
